<template>
  <div
    ref="popupModal"
    :class="`modal fade invoice-popup-container invoice-popup-modal${
      bookingInvoiceDataInfo?.id ?? invoiceIdProp
    }`"
    tabindex="-1"
    role="dialog"
    :id="
      fromIssuePage !== null
        ? `invoice-popup${bookingId ?? bookingIdProp}${fromIssuePage}`
        : `invoice-popup${bookingId ?? bookingIdProp}`
    "
  >
    <div
      :class="{
        'modal-dialog': true,
        'width-100-of-container': fromIssuePage !== null,
      }"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header new-design text-left">
          <h5 class="modal-title d-inline">
            {{
              MergedInvoiceId
                ? (bookingInvoiceDataInfo || {}).merged_invoice_num
                : (bookingInvoiceDataInfo || {}).invoice_num
            }}
            <div class="btn-group pair_btn_new_uniq">
              <button
                data-toggle="dropdown"
                data-too="tooltip"
                data-placement="bottom"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn btn-default dropdown-toggle create-btn FontSize"
              >
                <i
                  class="fa fa-ellipsis-v"
                  style="color: rgba(138, 138, 138, 1); font-size: 18px"
                ></i>
              </button>

              <payment-actions-dropdown
                v-if="bookingInvoiceDataInfo"
                @invoiceTypeChanged="handleInvoiceTypeChange"
                @statusColorChanged="handleStatusColorTypeChange"
                :payment-details="paymentDetailsInfo"
                :logged-user="loggedUserInfo"
                :booking-invoice="bookingInvoiceDataInfo"
                :booking-payment-summary="bookingPaymentSummaryDataInfo"
                from="childComponent"
                :apply-discount-and-close-invoice="applyDiscountAndCloseInvoice"
                :company-has-default-payment-gateway="
                  companyHasDefaultPaymentGatewayInfo
                "
              >
              </payment-actions-dropdown>
            </div>
            <span
              :class="{
                'status-label labels-font font-family-Roboto m-right-5 position-status-invoice-modal cursor-pointer': true,
                'line-height-36':
                  MergedInvoiceId &&
                  (bookingInvoiceDataInfo || {}).invoice_labels.length > 0,
              }"
              :style="color"
              v-if="bookingInvoiceDataInfo"
              data-toggle="modal"
              data-target="#popupi"
              @click="Invoice_Preview_Data((bookingInvoiceDataInfo || {}).id)"
            >
              {{ (bookingInvoiceDataInfo || {}).invoice_type }}
            </span>
          </h5>
          <svg
            class="close-icon clickable"
            @click.stop="closePaymentInvoicePopup"
            data-dismiss="modal"
            aria-label="Close"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
              fill="#2E4051"
            />
          </svg>
        </div>

        <div class="modal-body">
          <div class="row text-left">
            <div class="col-md-6 p-left-0 p-right-0">
              <div class="col-md-12">
                <span class="booking_title">Issue date</span>
              </div>
              <div class="col-md-12 booking_item">
                {{
                  (bookingInvoiceDataInfo || {}).merged_created ??
                  (bookingInvoiceDataInfo || {}).created
                }}
              </div>
            </div>
            <div class="col-md-6 p-left-0 p-right-0">
              <div class="col-md-12 p-left-0">
                <div class="col-md-12">
                  <span class="booking_title">Due Date</span>
                  <span id="">
                    <a
                      data-toggle="modal"
                      data-target="#popupi"
                      @click="Set_invoice_Due_Date(bookingId)"
                      class="details_info_opt"
                    >
                      <svg
                        data-v-42abf014=""
                        width="13"
                        height="13"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          data-v-42abf014=""
                          d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
                          fill="#2E4051"
                        ></path>
                      </svg>
                    </a>
                  </span>
                </div>
                <div class="col-md-12 p-left-0">
                  <div class="col-md-4 booking_item">
                    {{
                      (bookingInvoiceDataInfo || {}).invoice_due_date_formatted
                    }}
                  </div>
                  <div class="col-md-8">
                    <span
                      style="cursor: pointer"
                      data-toggle="modal"
                      data-target="#popupi"
                      @click="Set_invoice_Due_Date(bookingId)"
                      :class="{
                        'status-label labels-font font-family-Roboto orange-color': true,
                      }"
                    >
                      {{ (bookingInvoiceDataInfo || {}).due_date_days_message }}
                    </span>
                  </div>
                </div>
              </div>
              <!--                                <div class="col-md-12 p-top-15">-->
              <!--                                    <label class="figma-switch">-->
              <!--                                        <input id="toggle-attribute" checked-->
              <!--                                               class=""-->
              <!--                                               type="checkbox"-->
              <!--                                               @click="">-->
              <!--                                        <span class="slider round" for="toggle-attribute"> </span>-->
              <!--                                    </label>-->
              <!--                                    <span class="booking_item">Send reminder if overdue</span>-->
              <!--                                </div>-->
            </div>
          </div>
          <hr />
          <div class="row text-left">
            <div class="col-md-6 p-left-0 p-right-0" v-if="canSeeCustomer || loggedUser?.role_name != 'contractor'">
              <div class="col-md-12">
                <span class="booking_title">Sent to:</span>
              </div>
              <div
                :id="'customer_name' + customerInfo.customer_id"
                class="a_link_black FontSize mobile-font-size customer-technician"
                style="
                  color: black !important;
                  cursor: pointer;
                  min-width: 120px;
                "
              >
                <a>
                  <div class="col-md-12 booking_item">
                    {{ (bookingInvoiceDataInfo || {}).first_name }}
                    {{ (bookingInvoiceDataInfo || {}).last_name }}
                    <div
                      class="showContactDetailsIcon dropbtn"
                      style="display: inline-block"
                    >
                      <span class="caret"></span>
                    </div>
                  </div>
                </a>
              </div>
              <customer-dropdown
                v-if="(loggedUserInfo || {}).role_id != 9"
                :customer="customerInfo"
                :contact_data="contactDataInfo"
                :booking-info="bookingInfo"
              >
              </customer-dropdown>
            </div>
            <div v-else class="col-md-6 p-right-0" style="padding-left: 15px">
              <span class="select-services-dropdown-title">Customer details hidden</span>
              <p style="margin-top: 0 !important; color: rgb(63 61 61); font-size: 14px">Access to customer details is currently disabled by your admin.
                This is not an error. Please contact your admin if you need access.</p>
            </div>

            <div class="col-md-6 p-left-0 p-right-0" >
              <div class="col-md-12">
                <span class="booking_title">From:</span>
              </div>
              <div class="col-md-12 booking_item">
                {{ (bookingInvoiceDataInfo || {}).trading_name }}
              </div>
            </div>
          </div>
          <hr />
          <div
            class="row text-left"
            v-if="(bookingInvoiceDataInfo || {}).booking_customer_share == null"
          >
            <div class="col-md-12">
              <span class="booking_title">
                {{
                  (bookingInvoiceDataInfo || {}).merged_bookings?.length > 1
                    ? "Bookings"
                    : "Booking"
                }}
              </span>
            </div>
            <div class="col-md-12">
              <div
                class="col-md-12 p-left-0 p-right-0"
                style="padding: 12px 0px 12px 0px"
                v-if="(bookingInvoiceDataInfo || {}).merged_bookings"
                v-for="(bok, index) of (bookingInvoiceDataInfo || {})
                  .merged_bookings"
              >
                <div class="booking_item">
                  <span
                    v-if="viewPage && !MergedInvoiceId"
                    class="a_black m-right-5"
                    >{{ bok.booking_num }} ({{ bok.status_name }})</span
                  >
                  <a
                    v-else
                    :href="`/booking/view/${bok.booking_id}`"
                    class="a_black m-right-5"
                    >{{ bok.booking_num }} ({{ bok.status_name }}) View
                    booking</a
                  >
                  <i
                    ref="toggleCollapseModalIcon"
                    class="fa fa-chevron-down booking-title-toggle rotate float-right cursor-pointer"
                    @click="toggleCollapseModal(bok, $event)"
                  ></i>
                  <span
                    style="font-size: 16px; color: #2e4051"
                    class="float-right mr-2"
                    >{{ (currencyInfo || {}).currency_symbol
                    }}{{ bok.qoute }}</span
                  >

                  <div
                    :class="{
                      collapsed: bok.modalIsCollapsed,
                      'content-service m-top-10': true,
                    }"
                  >
                    <div class="row p-bottom-10 service_item_header">
                      <div class="col-md-5 p-right-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 labels-font font-family-Roboto"
                        >
                          Description
                        </div>
                      </div>
                      <div class="col-md-1 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 labels-font font-family-Roboto"
                        >
                          Price
                        </div>
                      </div>
                      <div class="col-md-1 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 labels-font font-family-Roboto"
                        >
                          Qty
                        </div>
                      </div>
                      <div class="col-md-2 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 labels-font font-family-Roboto"
                        >
                          Extra Charge
                        </div>
                      </div>
                      <div class="col-md-2 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 labels-font font-family-Roboto"
                        >
                          Discount
                        </div>
                      </div>
                      <div class="col-md-1 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 labels-font font-family-Roboto"
                        >
                          Total
                        </div>
                      </div>
                    </div>
                    <div
                      class="row service_item"
                      v-for="service of bok.services"
                    >
                      <div class="col-md-5 p-right-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 font-family-Roboto"
                        >
                          {{ service.service_name }}
                        </div>
                      </div>
                      <div class="col-md-1 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 font-family-Roboto"
                        >
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            service.coast.Price.value
                              ? service.coast.Price.value
                              : 0
                          }}
                        </div>
                      </div>
                      <div class="col-md-1 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 font-family-Roboto"
                          v-if="
                            service && service.coast && service.coast.Quantity
                          "
                        >
                          {{
                            service.coast.Quantity.value
                              ? service.coast.Quantity.value
                              : 1
                          }}
                        </div>
                      </div>
                      <div class="col-md-2 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 font-family-Roboto"
                        >
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            service.coast.Extra_Charge.value
                              ? service.coast.Extra_Charge.value
                              : 0
                          }}
                        </div>
                      </div>
                      <div class="col-md-2 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 font-family-Roboto"
                        >
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            service.coast.Discount.value
                              ? service.coast.Discount.value
                              : 0
                          }}
                        </div>
                      </div>
                      <div class="col-md-1 p-right-0 p-left-0">
                        <div
                          class="col-md-12 p-left-5 p-right-5 font-family-Roboto"
                        >
                          {{ (currencyInfo || {}).currency_symbol
                          }}{{ service.extra_charge }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="row p-bottom-10 service_item_content_mobile"
                      v-for="service of bok.services"
                    >
                      <div class="col-xs-8">
                        <div class="col-md-12 font-family-Roboto">
                          {{ service.service_name }}
                        </div>
                      </div>
                      <div class="col-xs-4">
                        <div class="col-md-12 font-family-Roboto float-right">
                          {{ (currencyInfo || {}).currency_symbol
                          }}{{ service.extra_charge }}
                        </div>
                      </div>
                      <div class="col-xs-12">
                        <div class="col-md-12 font-family-Roboto">
                          <!--       <sup>Qty</sup>-->
                          <!--       <sup>Price</sup>-->
                          <!--       <sup>{{ service.coast.Extra_Charge.value ? 'Extra' : '' }}</sup>-->
                          <!--       <sup>{{ service.coast.Discount.value ? 'Discount' : '' }}</sup>-->
                          <span
                            v-if="
                              service && service.coast && service.coast.Quantity
                            "
                          >
                            {{
                              service.coast.Quantity.value
                                ? service.coast.Quantity.value
                                : 1
                            }}
                          </span>
                          <span> * </span>
                          <span> {{ service.coast.Price.value }} </span>
                          <span>
                            {{ service.coast.Extra_Charge.value ? "+ " : " " }}
                          </span>
                          <span>
                            {{
                              service.coast.Extra_Charge.value
                                ? service.coast.Extra_Charge.value
                                : ""
                            }}
                            {{ service.coast.Discount.value ? " - " : " " }}
                          </span>
                          <span>
                            {{
                              service.coast.Discount.value
                                ? service.coast.Discount.value
                                : ""
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr
                  style="margin: 10px 0 0 0"
                  v-if="
                    index !==
                    (bookingInvoiceDataInfo || {}).merged_bookings.length - 1
                  "
                />
              </div>
            </div>
          </div>
          <div
            class="row text-left"
            v-if="(bookingInvoiceDataInfo || {}).booking_customer_share != null"
          >
            <div class="col-md-12">
              <span class="booking_title"
                >{{
                  (bookingInvoiceDataInfo || {}).merged_bookings.length > 1
                    ? "Bookings"
                    : "Booking"
                }}
              </span>
            </div>
            <div class="col-md-12">
              <div
                class="col-md-12 p-left-0 p-right-0"
                style="padding: 12px 0px 12px 0px"
                v-if="(bookingInvoiceDataInfo || {}).merged_bookings"
                v-for="(bok, index) of (bookingInvoiceDataInfo || {})
                  .merged_bookings"
              >
                <div class="booking_item">
                  <span
                    v-if="viewPage && !MergedInvoiceId"
                    class="a_black m-right-5"
                    >{{ bok.booking_num }} ({{ bok.status_name }})</span
                  >
                  <a
                    v-else
                    :href="`/booking/view/${bok.booking_id}`"
                    class="a_black m-right-5"
                    >{{ bok.booking_num }} ({{ bok.status_name }}) View booking
                  </a>
                  <span
                    style="font-size: 16px; color: #2e4051"
                    class="float-right mr-2 m-right-15"
                    v-if="(bookingInvoiceDataInfo || {}).booking_customer_share"
                  >
                    {{ (currencyInfo || {}).currency_symbol }}
                    {{
                      (
                        bookingInvoiceDataInfo || {}
                      ).booking_customer_share?.toFixed(2)
                    }}
                  </span>
                  <span
                    style="font-size: 16px; color: #2e4051"
                    class="float-right mr-2 m-right-15"
                    v-else
                  >
                    {{ (currencyInfo || {}).currency_symbol }}
                    {{
                      (bookingPaymentSummaryDataInfo || {}).total?.toFixed(2)
                    }}
                  </span>
                </div>
                <hr
                  style="margin: 10px 0 0 0"
                  v-if="
                    index !==
                    (bookingInvoiceDataInfo || {}).merged_bookings.length - 1
                  "
                />
              </div>
            </div>
          </div>

          <div
            class="row text-left"
            v-if="(bookingInvoiceDataInfo || {}).booking_customer_share == null"
          >
            <div class="col-md-12 m-top-10" v-if="!isMobile">
              <div class="row">
                <div class="col-md-7" v-if="!isMobile"></div>
                <div class="col-md-5 p-right-0">
                  <div
                    :class="{
                      'col-md-12 col-xs-12 black font-size-16 p-right-0': true,
                      'text-right': !isMobile,
                      'background-color-gray': isMobile,
                    }"
                  >
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Subtotal</p></div>
                      <div class="col-md-6 col-xs-6">
                        <p>
                          {{ (bookingPaymentSummaryDataInfo || {}).sub_total }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6">
                        <p>
                          Tax
                          {{
                            (bookingInvoiceDataInfo || {}).tax_included
                              ? "(incl.)"
                              : ""
                          }}
                        </p>
                      </div>
                      <div
                        class="col-md-6 col-xs-6"
                        v-if="(bookingPaymentSummaryDataInfo || {}).tax"
                      >
                        <p>
                          {{ (bookingPaymentSummaryDataInfo || {}).tax.total }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Total</p></div>
                      <div class="col-md-6 col-xs-6">
                        <p>
                          {{ (currencyInfo || {}).currency_symbol
                          }}{{
                            (
                              bookingPaymentSummaryDataInfo || {}
                            ).total?.toFixed(2)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Paid</p></div>
                      <div class="col-md-6 col-xs-6">
                        <p>
                          {{ (currencyInfo || {}).currency_symbol
                          }}{{ totalPaid?.toFixed(2) }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Tip</p></div>
                      <div class="col-md-6 col-xs-6">
                        <p>
                          {{ (currencyInfo || {}).currency_symbol
                          }}{{ totalTip?.toFixed(2) }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6">
                        <p><b>Balance</b></p>
                      </div>
                      <div class="col-md-6 col-xs-6">
                        <p>
                          <b>
                            {{ (currencyInfo || {}).currency_symbol
                            }}{{ totalBalance?.toFixed(2) }}</b
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row text-left"
            v-if="(bookingInvoiceDataInfo || {}).booking_customer_share != null"
          >
            <div class="col-md-12 m-top-10" v-if="!isMobile">
              <div class="row">
                <div class="col-md-7" v-if="!isMobile"></div>
                <div class="col-md-5 p-right-0">
                  <div
                    :class="{
                      'col-md-12 col-xs-12 black font-size-16 p-right-0': true,
                      'text-right': !isMobile,
                      'background-color-gray': isMobile,
                    }"
                  >
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Subtotal</p></div>

                      <div
                        class="col-md-6 col-xs-6"
                        v-if="
                          (bookingInvoiceDataInfo || {}).booking_customer_share
                        "
                      >
                        <p>
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            (
                              bookingInvoiceDataInfo || {}
                            ).booking_customer_share?.toFixed(2)
                          }}
                        </p>
                      </div>
                      <div class="col-md-6 col-xs-6" v-else>
                        <p>
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            (
                              bookingPaymentSummaryDataInfo || {}
                            ).total?.toFixed(2)
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Total</p></div>
                      <div
                        class="col-md-6 col-xs-6"
                        v-if="
                          (bookingInvoiceDataInfo || {}).booking_customer_share
                        "
                      >
                        <p>
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            (
                              bookingInvoiceDataInfo || {}
                            ).booking_customer_share?.toFixed(2)
                          }}
                        </p>
                      </div>
                      <div class="col-md-6 col-xs-6" v-else>
                        <p>
                          {{ (currencyInfo || {}).currency_symbol }}
                          {{
                            (
                              bookingPaymentSummaryDataInfo || {}
                            ).total?.toFixed(2)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6"><p>Paid</p></div>
                      <div class="col-md-6 col-xs-6">
                        <p>
                          {{ (currencyInfo || {}).currency_symbol
                          }}{{ totalPaid?.toFixed(2) }}
                        </p>
                      </div>
                    </div>

                    <div class="col-md-12 col-xs-12">
                      <div class="col-md-6 col-xs-6">
                        <p><b>Balance</b></p>
                      </div>
                      <div
                        class="col-md-6 col-xs-6"
                        v-if="
                          (bookingInvoiceDataInfo || {}).booking_customer_share
                        "
                      >
                        <p>
                          <b>
                            {{ (currencyInfo || {}).currency_symbol
                            }}{{
                              (
                                bookingInvoiceDataInfo || {}
                              ).booking_customer_share?.toFixed(2)
                            }}</b
                          >
                        </p>
                      </div>
                      <div class="col-md-6 col-xs-6" v-else>
                        <p>
                          <b>
                            {{ (currencyInfo || {}).currency_symbol
                            }}{{ totalBalance?.toFixed(2) }}</b
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div
            class="col-xs-12 text-left black font-size-16 background-color-gray p-all-20"
            v-show="isMobile"
          >
            <div class="col-xs-12 p-right-0 p-left-0">
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0">
                <p>Subtotal</p>
              </div>
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0 text-right">
                <p>
                  {{ (bookingPaymentSummaryDataInfo || {}).sub_total }}
                </p>
              </div>
            </div>
            <div class="col-xs-12 p-right-0 p-left-0">
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0">
                <p>
                  Tax
                  {{
                    (bookingInvoiceDataInfo || {}).tax_included ? "(incl.)" : ""
                  }}
                </p>
              </div>
              <div
                class="col-md-6 col-xs-6 p-right-0 p-left-0 text-right"
                v-if="(bookingPaymentSummaryDataInfo || {}).tax"
              >
                <p>{{ (bookingPaymentSummaryDataInfo || {}).tax.total }}</p>
              </div>
            </div>
            <div class="col-xs-12 p-right-0 p-left-0">
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0">
                <p>Total</p>
              </div>
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0 text-right">
                <p>
                  {{ (currencyInfo || {}).currency_symbol
                  }}{{
                    (bookingPaymentSummaryDataInfo || {}).total?.toFixed(2)
                  }}
                </p>
              </div>
            </div>
            <div class="col-xs-12 p-right-0 p-left-0">
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0">
                <p>Paid</p>
              </div>
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0 text-right">
                <p>
                  {{ (currencyInfo || {}).currency_symbol
                  }}{{ totalPaid?.toFixed(2) }}
                </p>
              </div>
            </div>
            <div class="col-xs-12 p-right-0 p-left-0">
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0"><p>Tip</p></div>
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0 text-right">
                <p>
                  {{ (currencyInfo || {}).currency_symbol
                  }}{{
                    (
                      bookingPaymentSummaryDataInfo || {}
                    ).tip?.total_tip?.toFixed(2)
                  }}
                </p>
              </div>
            </div>
            <div class="col-xs-12 p-right-0 p-left-0">
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0">
                <p><b>Balance</b></p>
              </div>
              <div class="col-md-6 col-xs-6 p-right-0 p-left-0 text-right">
                <p>
                  <b
                    >{{ (currencyInfo || {}).currency_symbol
                    }}{{ totalBalance?.toFixed(2) }}</b
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="row text-left" v-if="(paymentDetailsInfo || {}).length">
            <div class="col-md-12">
              <span class="booking_title">Payments received</span>
            </div>
            <input type="hidden" id="payment_vue" value="" />

            <div class="col-md-12">
              <div
                v-if="itemType != 'estimate'"
                :class="{ collapsed: false, 'p-top-20': true }"
              >
                <div class="row text-color-black font-size-14">
                  <payment-row
                    v-for="(paymentDetail, index) in paymentDetailsInfo"
                    :key="paymentDetail.id"
                    :index="index"
                    :modal-invoice="true"
                    :length="(paymentDetailsInfo || {}).length"
                    :payment-detail="paymentDetail"
                    :booking-invoice="bookingInvoiceDataInfo"
                    :calculate-prices-method="calculatePrices"
                    :get-payments-method="getPayments"
                    @delete-payment="deletePayment(index)"
                    :currency="currencyInfo"
                  ></payment-row>
                </div>
              </div>
            </div>
          </div>
          <hr v-if="(paymentDetailsInfo || {}).length" />
          <div class="row text-left">
            <div class="ibox payment_to_fieldworker">
              <div>
                <field-worker-earnings
                  v-if="
                    showPaymentModalEarningDataInfo && itemType === 'booking'
                  "
                  :booking-id="bookingId"
                  :is-modal="true"
                  :item-type="itemType"
                  :item-id="bookingId"
                  merged-invoice-id="0"
                  :has-recurring="hasRecurring"
                  :booking-nums="bookingNums"
                >
                </field-worker-earnings>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer new-design"></div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentActionsDropdown from "@/modules/Payment/components/partial/PaymentActionsDropdown.vue";
import CustomerDropdown from "@/modules/Customer/components/CustomerDropdown.vue";
import PaymentRow from "@/modules/Payment/components/PaymentRow.vue";
import { getPaymentsDetails } from "@/modules/Payment/api";
import { EventBus } from "@/events/event-bus";

export default {
  name: "PaymentInvoicePopup",
  components: { PaymentRow, CustomerDropdown, PaymentActionsDropdown },
  props: {
    fromIssuePage: {
      type: Number,
      default: null,
    },
    bookingInvoiceData: {},
    canSeeCustomer: null,
    bookingPaymentSummaryData: {},
    paymentDetails: {},
    showPaymentModalEarningData: {
      default: true,
    },
    itemType: {
      default: "booking",
    },
    statusColor: null,
    hasRecurring: false,
    viewPage: false,
    bookingIdProp: {},
    invoiceIdProp: {},
    mergedInvoiceIdProp: {},
    companyHasDefaultPaymentGateway: true,
    loggedUser: {},
    bookingNums: {},
    currency: {},
  },
  data() {
    return {
      MergedInvoiceId: (this.bookingInvoiceData || {}).merged_invoice_id
        ? (this.bookingInvoiceData || {}).merged_invoice_id
        : (this.bookingInvoice || {}).merged_invoice_id
        ? (this.bookingInvoice || {}).merged_invoice_id
        : null,
      bookingId: (this.bookingInvoiceData || {}).booking_id
        ? (this.bookingInvoiceData || {}).booking_id
        : (this.bookingInvoice || {}).booking_id
        ? (this.bookingInvoice || {}).booking_id
        : null,
      invoiceID: (this.bookingInvoiceData || {}).id
        ? (this.bookingInvoiceData || {}).id
        : (this.bookingInvoice || {}).id
        ? (this.bookingInvoice || {}).id
        : null,
      statusColorData: this.statusColor,
      getSummaryAndInvoice: 0,
      bookingInvoiceDataInfo: this.bookingInvoiceData,
      bookingPaymentSummaryDataInfo: this.bookingPaymentSummaryData,
      paymentDetailsInfo: this.paymentDetails,
      showPaymentModalEarningDataInfo: this.bookingIdProp
        ? false
        : this.showPaymentModalEarningData,
      customerInfo: [],
      contactDataInfo: [],
      loggedUserInfo: this.loggedUser,
      currencyInfo: this.currency,
      companyHasDefaultPaymentGatewayInfo: this.companyHasDefaultPaymentGateway,
      bookingInfo: {},
      applyDiscountAndCloseInvoice: 0,
    };
  },

  methods: {
    closePaymentInvoicePopup() {
      $(this.$refs["popupModal"]).modal("hide");
      $(".modal-backdrop").remove();

      // $(`#invoice-popup${this.bookingId}`).modal("hide");
    },
    getPayments() {
      getPaymentsDetails({
        booking_id: this.bookingId,
        invoice_id: this.invoiceID,
        merged_invoice_id: this.MergedInvoiceId,
        get_summary_and_invoice: this.getSummaryAndInvoice,
        get_childs: this.viewPage,
      }).then((response) => {
        this.paymentDetailsInfo = response.data.paymentDetails;
        this.applyDiscountAndCloseInvoice =
          response.data.apply_discount_and_close_invoice;
        if (response.data.bookingPaymentSummary) {
          this.bookingPaymentSummaryDataInfo =
            response.data.bookingPaymentSummary;
        }
        if (response.data.bookingInvoice) {
          this.bookingInvoiceDataInfo = response.data.bookingInvoice;
          this.$nextTick(() => {
            this.addModalListners();
          });
        }
        if (
          response.data.bookingInvoice &&
          response.data.bookingInvoice.hasRecurring
        ) {
          this.hasRecurring = response.data.bookingInvoice.hasRecurring;
        }
        if (
          response.data.bookingInvoice &&
          response.data.bookingInvoice.style_color
        ) {
          this.statusColorData =
            response.data.bookingInvoiceData &&
            response.data.bookingInvoiceData.style_color
              ? "background-color:" +
                response.data.bookingInvoiceData.style_color
              : (response.data.bookingInvoice || {}).style_color
              ? "background-color:" +
                (response.data.bookingInvoice || {}).style_color
              : "R";
        }

        if (response.data.customer) {
          this.customerInfo = response.data.customer;
        }
        if (response.data.contactData) {
          this.contactDataInfo = response.data.contactData;
        }
        if (response.data.loggedUser) {
          this.loggedUserInfo = response.data.loggedUser;
        }
        if (response.data.currency) {
          this.currencyInfo = response.data.currency;
        }
        if (response.data.companyHasDefaultPaymentGateway) {
          this.companyHasDefaultPaymentGatewayInfo =
            response.data.companyHasDefaultPaymentGateway;
        }
        if (response.data.bookingInfo) {
          this.bookingInfo = response.data.bookingInfo;
        }

        this.getSummaryAndInvoice = 0;
        if (this.bookingPaymentSummaryDataInfo) {
          this.calculatePrices();
        }
        if (this.openInvoicePopup) {
          this.$nextTick(() => {
            $(
              `.invoice-popup-modal${(this.bookingInvoiceDataInfo || {}).id}`
            ).modal("show");
            this.openInvoicePopup = false;
          });
        }
      });
    },
    Invoice_Preview_Data(id = 0, merged_invoice_id = 0) {
      if (merged_invoice_id === null) {
        merged_invoice_id = 0;
      }
      window.popupi(
        "Invoice Preview",
        `/invoice/preview/${id}?booking_id=${id}&merged_invoice_id=${merged_invoice_id}`
      );
    },
    calculatePrices() {
      let paid = 0;
      let tip = 0;
      let approvedPayemnts = (this.paymentDetailsInfo || {}).filter(
        (payment) =>
          payment.is_approved && !payment.is_rejected && !payment.is_deleted
      );
      for (let approvedPayemnt of approvedPayemnts) {
        if (approvedPayemnt.type === "refund") {
          paid -= +approvedPayemnt.total_paid;
          tip -= +approvedPayemnt.tip;
        } else {
          paid += +approvedPayemnt.total_paid;
          tip += +approvedPayemnt.tip;
        }
      }
      (this.bookingPaymentSummaryDataInfo || {}).paid_amount = paid;
      (this.bookingPaymentSummaryDataInfo || {}).tip.total_tip = tip;
    },
    deletePayment(booking_id = 0, payment_id = 0, id) {
      let url = `/payment/delete?booking_id=${booking_id}&id=${payment_id}`;
      /**
       *  Updated BY KAREEM
       *  data of the confirm popup ( it will show in the popup )
       *  our new confirm popup
       * */
      var data = {
        title: "Confirm delete",
        message: "Are you sure you want to delete this payment?",
        confirm: "Delete",
        cancel: "Cancel",
      };
      let vm = this;
      confirm_popup(
        data,
        function () {
          axios.post(url).then(function (response) {
            if (response.data.type === "success") {
              $(`#payment-details-${id}`).modal("hide");
              $.notify(response.data.msg, "success");
              vm.$emit("delete");
            } else {
              $.notify(response.data.msg, "error");
            }
            return;
          });
        },
        function () {}
      );
    },
    toggleCollapseModal(bok, event) {
      (this.bookingInvoiceDataInfo || {}).merged_bookings.forEach((booking) => {
        if (bok.booking_id === booking.booking_id) {
          this.$set(booking, "modalIsCollapsed", !booking.modalIsCollapsed);
          // Use the event target to find the nearest toggleIcon
          const toggleIcon = event.target.closest(".fa-chevron-down");
          if (toggleIcon) {
            $(toggleIcon).toggleClass("rotate-180");
          }
        }
      });
    },
    getWidth() {
      let xWidth = null;
      if (window.screen != null) xWidth = window.screen.availWidth;

      if (window.innerWidth != null) xWidth = window.innerWidth;

      if (document.body != null) xWidth = document.body.clientWidth;

      return xWidth;
    },
    handleInvoiceTypeChange(newType) {
      (this.bookingInvoiceDataInfo || {}).invoice_type = `${newType}`;
    },
    handleStatusColorTypeChange(newColor) {
      this.statusColorData = newColor;
    },
    Set_invoice_Due_Date(booking_id = 0) {
      window.popupi(
        "Set invoice Due Date",
        `/invoices/set-due-date/${booking_id}?booking_id=${booking_id}`
      );
    },
    addModalListners() {
      $(this.$refs["popupModal"]).on("shown.bs.modal", (e) => {
        if (!this.bookingInvoiceDataInfo) {
          this.bookingId = this.bookingIdProp;
          this.invoiceID = this.invoiceIdProp;
          this.mergedInvoiceId = this.mergedInvoiceIdProp;
          this.getSummaryAndInvoice = true;
          this.getPayments();
          this.showPaymentModalEarningDataInfo = true;
          this.$emit("modalOpened", this.showPaymentModalEarningDataInfo);
        }
        let fullString = this.$refs["popupModal"].id; // Example string with numeric ID
        let bookingId = fullString.match(/\d+/)[0]; // This will extract only the numeric part
        if (this.bookingId == bookingId && this.bookingInvoiceDataInfo) {
          this.showPaymentModalEarningDataInfo = true;
          this.$emit("modalOpened", this.showPaymentModalEarningDataInfo);
          this.getSummaryAndInvoice = 0;
          this.getPayments();
        }
      });
      $(this.$refs["popupModal"]).on("hidden.bs.modal", (e) => {
        let fullString = this.$refs["popupModal"].id; // Example string with numeric ID
        let bookingId = fullString.match(/\d+/)[0]; // This will extract only the numeric part
        this.dataLoaded = false;
        if (this.bookingId == bookingId) {
          this.showPaymentModalEarningDataInfo = false;
          this.$emit("modalOpened", this.showPaymentModalEarningDataInfo);
        }
      });
    },
  },
  computed: {
    color() {
      return this.statusColorData;
    },
    totalBalance() {
      return (
        (this.bookingPaymentSummaryDataInfo || {}).total -
        (this.bookingPaymentSummaryDataInfo || {}).paid_amount
      );
    },
    totalPaid() {
      return (this.bookingPaymentSummaryDataInfo || {}).paid_amount;
    },
    totalTip() {
      return this.bookingPaymentSummaryDataInfo
        ? ((this.bookingPaymentSummaryDataInfo || {}).tip || {}).total_tip
        : 0;
    },
    isMobile() {
      return this.getWidth() <= 768;
    },
  },
  watch: {
    customer(newCustomer, oldCustomer) {
      this.customerInfo = newCustomer;
    },
    contactData(newContactData, oldContactData) {
      this.contactDataInfo = newContactData;
    },
  },
  mounted() {
    EventBus.$on("onCustomerUpdated", (customerData, contactData) => {
      this.getPayments();
    });
    this.addModalListners();
  },
};
</script>

<style scoped>
.font-size-14 {
  font-size: 14px;
}

.text-color-black {
  color: #000;
}
.modal {
  overflow: auto !important;
}

.service_item_content_mobile {
  display: none;
}
.booking-title-toggle {
  padding: 3px 0px 0px 7px;
}
.booking-title-toggle::before {
  padding: 0px 7px 3px 0px;
}
.service_item_header {
  padding: 8px 0px 8px 0px;
}
.service_item {
  padding: 8px 0px 8px 0px;
  //border-bottom:  1px solid #EAECEE;
}
.service_item:last-child {
  border-bottom: 0px solid #000;
}
.booking_title {
  font-weight: 700;
  font-size: 14px;
  color: #2e4051;
}
.booking_item {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2e4051;
}
.status-label {
  color: #ffffff !important;
  border-radius: 100px !important;
  padding: 2px 8px 4px 8px !important;
}

.border-style {
  border-right: 1px solid;
  border-color: #eaecee;
}

.labels-font {
  font-size: 14px;
  font-weight: 700;
  color: #2e4051;
}

.font-family-Roboto {
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #2e4051;
}

.collapsed {
  display: none;
}

.rotate {
  -moz-transition: all 0.5s linear;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
}

.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
  display: inline-block;
}

.position-status {
  position: relative;
  bottom: 2px;
}
.position-status-invoice-modal {
  position: relative;
  bottom: 4px;
}
.p-bottom-desktop-8 {
  padding-bottom: 8px;
}

.pair_btn_new_uniq .create-btn {
  border: none !important;
}

.cursor-pointer {
  cursor: pointer;
}

.icon-position {
  position: relative;
  top: 4px;
  left: 2px;
}

.btns-change-data {
  padding: 3px 6px !important;
  position: relative;
  bottom: 2px;
}

.cancel-btn {
  padding: 3px 7px !important;
}

.width-100px {
  width: 100px;
}

.modal-header.new-design {
  border-bottom: unset;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
  font-family: "Roboto", serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #2e4051;
  display: inline;
}

.modal-footer.new-design {
  border-top: unset;
}

.close-icon {
  float: right;
}

.clickable {
  cursor: pointer;
}

.white-space-nowrap {
  white-space: nowrap;
}

.line-height-36 {
  line-height: 36px;
}

.left-12 {
  left: 12px;
}

.content-service {
  background-color: #f9f9fa;
  border-radius: 12px;
  padding: 8px;
}
.background-color-gray {
  background-color: #f9f9fa;
  border-radius: 12px;
}
.p-all-20 {
  padding: 20px;
}
@media (max-width: 768px) {
  .mobile-p-left-4 {
    padding-left: 4px;
  }

  .mobile-position {
    position: relative;
    bottom: 95px;
    left: 95px;
  }
  .service_item {
    display: none;
  }
  .service_item_header {
    display: none;
  }

  .mobile-right-8 {
    right: -60px !important;
  }

  .service_item_content_mobile {
    display: block;
    padding: 10px 0px 0px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .mobile-position {
    left: 215px;
  }
  .service_item {
    display: none;
  }
  .service_item_header {
    display: none;
  }
  .threedots-p-left {
    padding-left: 30px;
  }

  .service_item_content_mobile {
    display: block;
    padding: 10px 0px 0px;
  }
  sup {
    font-size: smaller;
    vertical-align: super;
  }
}
</style>
<style>
.blue-color {
  background-color: #008cfa !important;
}

.green-color {
  background-color: #37bd5d !important;
}

.orange-color {
  background-color: #ff932f !important;
}
.red-color {
  background-color: #f44336 !important;
}
.gray-color {
  background-color: #979fa8 !important;
}
.width-100-of-container {
  width: 100% !important;
}
#matchedInvoicesTable .invoice-popup-container .modal-dialog {
  position: fixed !important;
  left: 135px !important;
}
@media (max-width: 992px) {
  #matchedInvoicesTable .invoice-popup-container .modal-dialog {
    left: 0px !important;
  }
}
</style>
